import { render, staticRenderFns } from "./RemindersSettings.vue?vue&type=template&id=0bf789fc&"
import script from "./RemindersSettings.vue?vue&type=script&lang=ts&"
export * from "./RemindersSettings.vue?vue&type=script&lang=ts&"
import style0 from "./RemindersSettings.vue?vue&type=style&index=0&id=0bf789fc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports